module.exports = __webpack_public_path__ + "static/img/M-715-TASSO.9c722a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-715-TASSO.png
// module id = NKrl
// module chunks = 0